import { render, staticRenderFns } from "./DefaultLayout.vue?vue&type=template&id=ffd2f11e&scoped=true"
import script from "./DefaultLayout.vue?vue&type=script&lang=js"
export * from "./DefaultLayout.vue?vue&type=script&lang=js"
import style0 from "./DefaultLayout.vue?vue&type=style&index=0&id=ffd2f11e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd2f11e",
  null
  
)

export default component.exports